module.exports = __webpack_public_path__ + "img/fuel-thruster.74dafb3c.png";